import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { useTranslation } from 'react-i18next';
import { usePhotoUri } from './media';
import Photo from '../components/Photo';
import type { MediaRef } from '../types';

export default function MediaAttachment({
  media,
  seed,
  style,
}: {
  media: MediaRef;
  seed: string;
  style?: StyleProp<ViewStyle>;
}) {
  const { t } = useTranslation();
  const uri = usePhotoUri(media);
  if (media.mimeType?.startsWith('video/'))
    return (
      <View style={style}>
        <video
          src={uri ?? undefined}
          controls
          playsInline
          preload="metadata"
          aria-label={t('relay.playVideo')}
          style={{ width: '100%', height: '100%', borderRadius: 18 }}
        />
      </View>
    );
  return <Photo media={media} seed={seed} style={style} />;
}
